export default __webpack_public_path__ + "static/media/pokedex-mb-detail.0046d26d.png";